const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  messageCount: state => state.app.messageCount,
  faultBackCount: state => state.app.faultBackCount,
  showElectronicScroll: state => state.app.showElectronicScroll,
  showDialog: state => state.app.showDialog,
  showNotify: state => state.app.showNotify,
  showDownloadLoading: state => state.app.showDownloadLoading,
  showDownloadLoadingText: state => state.app.showDownloadLoadingText,
  showAIProcessLoading: state => state.app.showAIProcessLoading,
  showAIProcessLoadingText: state => state.app.showAIProcessLoadingText,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  account: state => state.user.account,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
}
export default getters
